// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const regirock: PokeData = {
  "id": 377,
  "name": "regirock",
  "height": 17,
  "weight": 2300,
  "base_experience": 261,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "stomp",
    "hyper-beam",
    "rock-throw",
    "explosion",
    "rock-slide",
    "curse",
    "zap-cannon",
    "lock-on",
    "ancient-power",
    "superpower",
    "iron-defense",
    "hammer-arm",
    "stone-edge",
    "charge-beam",
    "bulldoze"
  ],
  "moves": [
    "rock-throw",
    "rock-slide",
    "curse",
    "zap-cannon",
    "ancient-power",
    "superpower",
    "seismic-toss",
    "stealth-rock",
    "stone-axe",
    "power-siphon",
    "boulder_bash",
    "rock-smash",
    "rock-blast"
  ],
  "evolution_chain": {
    "id": 193,
    "item": null,
    "species": [
      {
        "name": "regirock",
        "order": 407,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 174,
    "speed": 75,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
